import React, { FC } from "react";
import styled from "styled-components";
import LockIcon from "../icons/Lock";

type Props = {
  active?: boolean;
  disabled?: boolean;
  locked?: boolean;
} & React.HTMLProps<HTMLDivElement>;

/* eslint-disable @typescript-eslint/no-unused-vars */
const MobileBoxComponent: FC<Props> = ({
  active,
  disabled,
  locked,
  ...props
}) => {
  return (
    <div {...props}>
      {props.children}
      {locked && (
        <div className="lock-container">
          <LockIcon />
        </div>
      )}
    </div>
  );
};

const MobileBox = styled(MobileBoxComponent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: ${({ active, disabled }) =>
    disabled ? "var(--gray-300)" : active ? "var(--black)" : "var(--gray-300)"};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  filter: ${(p) => (p.disabled ? "grayscale(1)" : "none")};
  transition: 0.2s;
  position: relative;

  .lock-container {
    position: absolute;
    top: -2px;
    right: -2px;
    color: var(--gray-500);
    svg {
      width: 14px;
      height: 14px;
    }
  }

  svg {
    width: 2em;
    height: 2em;
  }
`;

export default MobileBox;
